var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"flex gap-2 mb-2"},[_c('div',{staticClass:"h-1 rounded-lg w-14",class:[_vm.lowBarClassName]}),_c('div',{staticClass:"h-1 rounded-lg w-14",class:[_vm.mediumBarClassName]}),_c('div',{class:{
        'h-1 rounded-lg w-14': true,
        'bg-gray-600': _vm.passwordStrength.type !== 'strong',
        'bg-green-600': _vm.passwordStrength.type === 'strong'
      }})]),_c('p',[_vm._v("Kata sandi Anda "),_c('span',{class:_vm.passwordStrengthLabelClassName},[_vm._v(_vm._s(_vm.passwordStrength.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }